import { AiOutlineFilePdf } from 'react-icons/ai';
import './geospatial.css'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';


function Geospatialpolicy() {

  const [policies, setPolicies] = useState([]);

  const getPolcies = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/viewweb/getwebpolicies`;
      const res = await axios.get(url);
      setPolicies(res?.data?.data);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getPolcies();
  }, [])


  return (
    <div className="geo-special-main-wrapper">
      <h4>Policies</h4>
      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Policy</th>
          </tr>
        </thead>
        <tbody>
          {
            policies.length && policies.map((policy) => 
              <tr key={policy.id}>
                <td><h3>{policy.title}</h3></td>
                <td>
                  <h3>
                    <Link to={policy.path} target="_blank" rel="noreferrer">
                      <AiOutlineFilePdf style={{ fontSize: 20, color: 'red', marginLeft: 5 }} />
                    </Link>
                  </h3>
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
    </div>
  );
}
export default Geospatialpolicy;